import { qsa } from "@meduza/dom";

import { section } from "@/glow";
import playButtonBlock from "@/lib/play-button-block";
import { animateImageWithText, shouldAnimate } from "@/lib/animation";

const selectors = {
  playButtonVideo: "[data-play-button-block-video]",
  playButtonBlock: ".play-button-block",
};

section("image-with-text", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateImageWithText = animateImageWithText(this.container);
    }
    const playButtonVideos = qsa(selectors.playButtonVideo, this.container);

    if (playButtonVideos.length) {
      this.playButtons = playButtonVideos.map(block =>
        playButtonBlock(block.closest(selectors.playButtonBlock))
      );
    }
  },

  onUnload() {
    this.animateImageWithText?.destroy();
    this.playButtons && this.playButtons.forEach(button => button.unload());
  },
});
